const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const track = (eventType, page) => {
  try {
    fetch(`${BACKEND_URL}/api/metrics`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event_type: eventType, page: page || window.location.pathname }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* analytics must never break the site */
  }
};
